module.exports = __webpack_public_path__ + "static/media/bp.c9ae0703.mp3";